import React, { useState } from "react";
import { CustomerViewDetailsViewProps } from "./customer-view-details-view.props";
import CustomerViewDetailsViewFullInfo from "./customer-view-details-view-full-info/customer-view-details-view-full-info";
import CustomerViewEditViewFullInfo from "../customer-view-details-edit/customer-view-edit-view-full-info/customer-view-edit-view-full-info";
import { AlertComponent } from "../../../../../common/components";
import "./customer-view-details-view.scss";

const CustomerViewDetailsView: React.FC<CustomerViewDetailsViewProps> = ({
  customerDetails,
  setLoading,
  selectedCustomerId,
  viewFullInfoOpen,
  setViewFullInfoOpen,
  uploadedImage,
  uploadedImageFile,
  removeImage,
  fetchCustomerDetails,
  onCustomerNameUpdate,
  resetImageUpload,
  handleFormSubmitError,
  disableCustomerStatus,
  permissions,
  isMobile,
}) => {
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertType, setAlertType] = useState<"success" | "error">("success");

  const handleAlertClose = () => {
    setAlertOpen(false);
  };

  const handleCancelUpdate = () => {
    setViewFullInfoOpen(false);
    fetchCustomerDetails();
  };

  return (
    <div className="customer-list-view-details-view-box">
      {viewFullInfoOpen ? (
        <CustomerViewEditViewFullInfo
          setViewFullInfoOpen={setViewFullInfoOpen}
          viewFullInfoOpen={viewFullInfoOpen}
          customerDetails={customerDetails}
          selectedCustomerId={selectedCustomerId}
          handleCancelUpdate={handleCancelUpdate}
          setAlertOpen={setAlertOpen}
          setAlertMessage={setAlertMessage}
          setAlertType={setAlertType}
          setLoading={setLoading}
          uploadedImage={uploadedImage}
          uploadedImageFile={uploadedImageFile}
          removeImage={removeImage}
          onCustomerNameUpdate={onCustomerNameUpdate}
          resetImageUpload={resetImageUpload}
          handleFormSubmitError={handleFormSubmitError}
          disableCustomerStatus={disableCustomerStatus}
          isMobile={isMobile}
        />
      ) : (
        <CustomerViewDetailsViewFullInfo
          setViewFullInfoOpen={setViewFullInfoOpen}
          viewFullInfoOpen={viewFullInfoOpen}
          customerDetails={customerDetails}
          permissions={permissions}
          isMobile={isMobile}
        />
      )}
      <AlertComponent
        message={alertMessage}
        type={alertType}
        open={alertOpen}
        onClose={handleAlertClose}
      />
    </div>
  );
};

export default CustomerViewDetailsView;
